export default "__VITE_ASSET__DA7W7MZD__"